/**
 * @generated SignedSource<<f17c6823c5a09f0856b3a140b2e0f6bb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TodoEditLinkProductQuery$variables = {
  todoId: string;
};
export type TodoEditLinkProductQuery$data = {
  readonly todo: {
    readonly linkedProducts: ReadonlyArray<{
      readonly id: string;
    }>;
  };
};
export type TodoEditLinkProductQuery = {
  response: TodoEditLinkProductQuery$data;
  variables: TodoEditLinkProductQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "todoId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "todoId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "StoreProduct",
  "kind": "LinkedField",
  "name": "linkedProducts",
  "plural": true,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TodoEditLinkProductQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v1/*: any*/),
          "concreteType": "Todo",
          "kind": "LinkedField",
          "name": "todo",
          "plural": false,
          "selections": [
            (v3/*: any*/)
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TodoEditLinkProductQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Todo",
        "kind": "LinkedField",
        "name": "todo",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "19709298f1b27fcaf1b8f3ea6e76909a",
    "id": null,
    "metadata": {},
    "name": "TodoEditLinkProductQuery",
    "operationKind": "query",
    "text": "query TodoEditLinkProductQuery(\n  $todoId: ID!\n) {\n  todo(id: $todoId) {\n    linkedProducts {\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "0358997c31e2898548c91204f81fcaf6";

export default node;
